// extracted by mini-css-extract-plugin
export default {"heroWrapper":"HeroSection_heroWrapper__ZAhJq","videoBackground":"HeroSection_videoBackground__Kk7al"};